import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../../form/Select';
import { incomes } from '../../utilities/inPageLeadFormData';

export const IncomeSelectInputComponent = React.forwardRef(({
  value,
  onChange,
  onBlur,
  error,
  errorMessage,
}, ref) => (
  <Select
    id='in-page-lead-form-income-range-select'
    label='Annual household income'
    ref={ref}
    name='incomeRange'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={onBlur}
    options={incomes}
    required={true}
    customTheme={'leads'}>
    {incomes.map(
      (option) => <option
        key={option.name}
        value={option.value}
        disabled={option.disabled}>
        {option.name}
      </option>,
    )}
  </Select>
));

IncomeSelectInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default IncomeSelectInputComponent;
